import {
  Box, Image, NavigationLinkGroup, NestedNavigation, Text,
} from '@domain-group/suit-theme'

import useSystemManagerNestedNavigation from '@hooks/useSystemManagerNestedNavigation'

interface SystemManagerNestedNavigationProps {
  navigationPayload: ReturnType<typeof useSystemManagerNestedNavigation>,
}

const SystemManagerNestedNavigation = (props: SystemManagerNestedNavigationProps) => {
  const { navigationPayload } = props
  const {
    entity,
    image,
    navigationItems,
    shouldUseNestedNavigation,
  } = navigationPayload

  if (!shouldUseNestedNavigation) return null

  return (
    <NestedNavigation>
      <Box flexDirection="column" flexShrink={0}>
        <Box padding="large" borderBottom="1px solid" borderColor="lineColor" flexDirection="column">
          <Image height={86} url={image} width={86} />
          <Text marginTop="xlarge">{entity?.title}</Text>
        </Box>

        <Box flexDirection="column">
          {navigationItems?.sections?.map(section => (
            <Box
              flexDirection="column"
              key={section.key}
              padding="large"
              borderBottom="1px solid"
              borderColor="lineColor"
            >
              {section.items?.map(item => (
                <NavigationLinkGroup key={item.key} link={item} secondaryNav sidebarMaximized />
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </NestedNavigation>
  )
}

export default SystemManagerNestedNavigation
